
// import { setCookie } from './cookie-helpers';

// export function manageUrlTags(urlStringQuery) {
//   if (urlStringQuery) {
//     const urlTags = new URLSearchParams(urlStringQuery);

//     // Manage unique Marketing User ID
//     const muid = urlTags.get('muid');
//     if (muid) {
//       setCookie('cvr_muid', muid, 7)
//     }
//   }
// }

export function manageDsrUrlTags(paramName) {
  if (window.location.search) {
    const urlTags = new URLSearchParams(window.location.search);
    const tagValue = urlTags.get(paramName);
    switch (paramName) {
      case('view'): {
        return `${tagValue}-subpage`;
      }
      case('atb'):
      case('viewpage'):
      case('uid'): {
        return `${tagValue}`;
      }
      default: {
        return "";
      }
    }

  } else return null;
}

export function queryParamArrayParser(fieldName, arrayOfStringValues) {
  
  if (Array.isArray(arrayOfStringValues)) {
  
    if (arrayOfStringValues.length > 0) {
      let parsedUrlSection = '';

      arrayOfStringValues.map((value) => {
        // if (parsedUrlSection !== '') {
          parsedUrlSection = parsedUrlSection + `&&${fieldName}[]=${value}` 
        // } 
        // else {
        //   parsedUrlSection = parsedUrlSection + `?${fieldName}[]=${value}` 
        // }

        return null; // No value needs to be returned
      })
  
      return parsedUrlSection;
    
    } else {
  
      return "" 
    }
    
  }
}

export function updateTagWithoutRender(key, value) {
  const url = new URL(window.location);
  url.searchParams.set(key, value);
  window.history.replaceState({}, "", url);
  window.dispatchEvent(new Event("url-changed"));
}